import * as R from 'ramda';

import {createSelector} from 'reselect';
import {getItemsArray} from 'redux/hor/module/selectors';

export const getClientAnsweredRequestsSelector = createSelector(
  state => state.requestsAnswered,
  getItemsArray
);

export const getClientAnsweredRequestParamsSelector = createSelector(
  state => state.requestsAnswered,
  R.compose(
    R.pick(['limit', 'offset', 'count']),
    R.defaultTo({})
  )
);